import { render, staticRenderFns } from "./Auth-layout.vue?vue&type=template&id=6c5a54ab&scoped=true&lang=pug&"
import script from "./Auth-layout.vue?vue&type=script&lang=js&"
export * from "./Auth-layout.vue?vue&type=script&lang=js&"
import style0 from "./Auth-layout.vue?vue&type=style&index=0&id=6c5a54ab&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c5a54ab",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAppBar } from 'vuetify/lib/components/VAppBar';
import { VContent } from 'vuetify/lib/components/VContent';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VAppBar,VContent,VSpacer})
